import { Typography } from "antd";
import type { TextProps } from "antd/es/typography/Text";
import React from "react";
import styled from "styled-components";
import type { Substitute } from "styled-components/dist/types";
import { Colors } from "utils";

type FontFamily = "Manrope"|"Comfortaa";
type IWeight = "bold"|"medium"|"regular"|"semiBold"
const customWeight: Record<IWeight, number> = {
    "bold": 700,
    "semiBold": 600,
    "medium": 500,
    "regular": 400,
}
export const AppText = styled(Typography.Text)<{
    fontFamily?: FontFamily;
    variant?: Colors;
    weight?: IWeight;
    size?: number; 
    align?: "center"|"start"|"end";
    cursor?: "pointer"|"auto";
}>`
    width: fit-content;
    text-align: ${({ align }) => align || "start"};
    cursor: ${({ cursor }) => cursor || "auto"};
    ${({ fontFamily, weight = "regular", variant, size = 16, theme: { colors } }) => `
        font-family: ${fontFamily || "Manrope"}-${weight?.charAt(0).toUpperCase()+weight?.substring(1)};
        font-size: ${size}px;
        line-height: ${size + 8}px;
        color: ${colors[variant || "text"]}; 
        font-weight: ${customWeight[weight]};   
    `}
`

export type AppTextProps = Substitute<TextProps & React.RefAttributes<HTMLSpanElement>, {
    fontFamily?: FontFamily;
    variant?: Colors;
    weight?: IWeight;
    size?: number;
    align?: "center" | "start" | "end";
    cursor?: "pointer" | "auto";
}>